import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import QuickExplore from "./components/QuickExplore";
import HotAnime from "./components/HotAnime";
import LatestNews from "./components/LatestNews";
import TopicSection from "./components/TopicSection";
import { heroSlides } from "@/mocks/heroSlides";
import { animes } from "@/mocks/animes";
import { newsList } from "@/mocks/news";

export default function Home() {
  return (
    <div className="w-full">
      <h1 className="sr-only">火狼动漫网 - 最新动漫资讯与热门动漫推荐</h1>
      <HeroCarousel slides={heroSlides} />
      <QuickExplore />
      <HotAnime />
      <LatestNews />
      <TopicSection />

      <section className="w-full px-4 md:px-8 pb-4">
        <div className="max-w-7xl mx-auto rounded-lg bg-primary-950 px-6 md:px-10 py-10 md:py-12 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-900 to-primary-950"></div>
          <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="max-w-xl">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
                关于火狼动漫网
              </h2>
              <p className="text-sm md:text-base text-background-300 leading-relaxed">
                我们致力于为动漫爱好者提供及时、准确的动漫资讯与详实的作品介绍，
                目前已收录 {animes.length} 部作品与 {newsList.length} 篇资讯，帮助你在海量内容中快速找到所爱。
              </p>
              <div className="mt-6 flex items-center gap-6">
                <div>
                  <div className="text-2xl font-bold text-accent-500">{animes.length}+</div>
                  <div className="text-xs text-background-400 mt-1">动漫作品库</div>
                </div>
                <div className="w-px h-10 bg-primary-700"></div>
                <div>
                  <div className="text-2xl font-bold text-accent-500">{newsList.length}+</div>
                  <div className="text-xs text-background-400 mt-1">精选资讯</div>
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 px-6 h-11 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap self-start cursor-pointer"
            >
              了解更多
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}